import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { RecoverPasswordState, selectRecoverPasswordState } from '../../store/password/password.selectors';
import { passwordActions } from '../../store/password/password.actions';
import { PasswordRecoverStatus } from '../../store/password/password.state';

@Component({
  selector: 'app-recover-password',
  templateUrl: './recover-password-view.component.html',
  styleUrls: ['./recover-password-view.component.scss'],
  standalone: false
})
export class RecoverPasswordViewComponent implements OnInit {
  protected recoverPasswordEmail: FormControl<string>;
  protected status$: Observable<RecoverPasswordState>;

  constructor(private store: Store) {
    this.recoverPasswordEmail = new FormControl('', {
      updateOn: 'change',
      validators: [Validators.required, Validators.email]
    });

    this.status$ = this.store.select(selectRecoverPasswordState);
  }

  ngOnInit(): void {
    this.store.dispatch(passwordActions.recover_password_page_open());
  }

  send(): void {
    if (!this.recoverPasswordEmail.invalid) {
      this.store.dispatch(passwordActions.recover_password_request_start({ email: this.recoverPasswordEmail.value }));
    }
  }

  protected readonly PasswordRecoverStatus = PasswordRecoverStatus;

  protected resendLink(email: string) {
    this.store.dispatch(passwordActions.recover_password_request_start({ email }));
  }
}
